import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const activateOl = async (id: number) => {
  return restApiClient.url(constructApiUrl(API.ols.activate.url, { id })).post()
}
